{"AR":{"USD":"UST"}}